import type { InspectionTemplateItemModel } from 'components/dataProviders/withRequiredInspectionTemplate/types';
import type { DocumentsOnTemplateView } from 'presentation/document/documentsOnTemplateView';
import { isRichTextEmpty } from 'shared/utils/richText';

export function hasGeneralNormContent(
  template: InspectionTemplateItemModel,
  templateDocuments: DocumentsOnTemplateView
): boolean {
  return (
    !isRichTextEmpty(template.generalNorm.description) ||
    templateDocuments.templateDocuments.length > 0
  );
}
